import { useSearchParams } from "react-router-dom";
import PostCheckout from "../components/site/PostCheckout";

// /gracias?pedido=<UUID> — muestra los primeros 8 caracteres del UUID en
// mayúsculas (ej. "Pedido #1A188786"). Sin el parámetro, misma página sin número.
export default function GraciasPage() {
  const [params] = useSearchParams();
  const raw = params.get("pedido") || "";
  const orderId = raw.replace(/[^a-zA-Z0-9]/g, "").slice(0, 8).toUpperCase();

  return (
    <PostCheckout
      eyebrow="Confirmación de pago"
      title="¡Pago recibido! 🎉"
      body="Tu pedido quedó confirmado. En unos segundos recibirás la confirmación por WhatsApp con los detalles."
      orderId={orderId}
      pageTitle="Pago recibido — SoyPacoIA"
    />
  );
}
